import { v4 as uid } from "uuid";
import { useConsumerStore } from "../store";

interface IWebsocketMessageOption {
  eventType: string;
  eventSubType: string;
  eventData: string;
}

interface IWebsocketMessage extends IWebsocketMessageOption {
  organizationId: number;
  personId: number;
  sourceApp: string;
  sessionId: string;
  externalUserId: string;
  authenticationId: string;
}

class WebsocketLoggerService {
  private readonly connection;
  private sessionId: string;
  private readonly authenticationId =
    useConsumerStore.getState().authenticationId;
  private readonly externalUserId = useConsumerStore.getState().consumer?.id;

  constructor() {
    this.connection = new WebSocket(
      `${process.env.REACT_APP_WEB_SOCKET_URL}/app-logs?client-id=${process.env.REACT_APP_WEB_SOCKET_CLIENT_ID}`,
      "echo-protocol"
    );

    // this.connection.onerror = () => {
    //   console.error("WebSocket error");
    // };

    // this.connection.onmessage = (data) => {
    //   console.log("WebSocket message received:", data);
    // };

    // this.connection.onclose = () => {
    //   console.log("WebSocket connection closed");
    // };

    this.connection.onopen = () => {
      const sessionId = sessionStorage.getItem("sessionId");
      if (!sessionId) {
        const sessionUuid = uid();
        this.sessionId = sessionUuid;
        sessionStorage.setItem("sessionId", sessionId);
        this.sendMessage({
          eventType: "Session Start",
          eventSubType: null,
          eventData: null,
        });
      }
    };
  }

  sendMessage = (option: IWebsocketMessageOption) => {
    if (this.connection.readyState === WebSocket.OPEN) {
      const externalUserId = (this.externalUserId || "").toString();
      const authenticationId = (this.authenticationId || "").toString();
      const message: IWebsocketMessage = {
        ...option,
        externalUserId,
        authenticationId,
        sessionId: this.sessionId,
        sourceApp: "CARE2U_WEB",
        organizationId: parseInt(process.env.REACT_APP_ORGANIZATION_ID),
        personId: null,
      };
      const stringifiedMessage = JSON.stringify(message);
      this.connection.send(stringifiedMessage);
    }
  };
}

const websocketLoggerService = new WebsocketLoggerService();

export default websocketLoggerService;
